import React from 'react'

const InfoSection = () => (
  <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
    <p className='txt-subtitle txt-font-body color-ui-2'>
      O valor pode ser creditado em até 10 dias úteis. Caso o valor não seja creditado nesse período, entre em contato com a nossa central de atendimento.
    </p>
  </div>
)

export default InfoSection



// WEBPACK FOOTER //
// ./src/features/FuelCredit/Sidebar/InfoSection.js